import { Logo } from "@components";
import PhoneFrame from "./PhoneFrame";
import GmailPreviewHeader from "./GmailPreviewHeader";
import { buildTokenReplacer } from "./templateUtils";

const EmailPreview = ({ values, merchant, previewTokens }) => {
  const replaceTokens = buildTokenReplacer(previewTokens);
  const primaryColour =
    merchant?.customisationSettings?.colourSet?.primary ?? "#991a2d";
  const buttonTextColour =
    merchant?.customisationSettings?.colourSet?.buttonText ?? "#ffffff";
  const merchantName = merchant?.name ?? "Your company";

  return (
    <PhoneFrame>
      <div className="flex flex-col h-full overflow-y-auto bg-white">
        <GmailPreviewHeader
          subject={replaceTokens(values?.emailSubject)}
          merchantName={merchantName}
          primaryColour={primaryColour}
        />
        <div className="p-2 bg-zinc-100">
          <div className="px-4 bg-white rounded-t-2xl">
            <div className="text-center">
              <div className="flex justify-center p-2 pt-4">
                <Logo
                  type="center"
                  brand={merchant?.organisationId}
                  height="64px"
                  width="140px"
                />
              </div>
            </div>
            <div
              className="text-center cursor-default mt-2 font-bold text-xl"
              dangerouslySetInnerHTML={{
                __html: replaceTokens(values?.emailTitle) || "Email title",
              }}
            />
            <div className="px-3 my-4">
              <div
                className="whitespace-pre-wrap text-[11px] cursor-default"
                dangerouslySetInnerHTML={{
                  __html: replaceTokens(values?.emailMainText),
                }}
              />
            </div>
            <div className="flex flex-col bg-zinc-100 rounded-2xl cursor-default p-3">
              <div>
                <div className="pb-2">
                  <span className="text-sm">
                    {replaceTokens(values?.emailActionTitle) || "Action title"}
                  </span>
                </div>
                <div className="pb-3">
                  <span className="text-lg font-semibold">
                    {replaceTokens(values?.amountDisplay)}
                  </span>
                </div>
              </div>
              <div className="flex justify-center w-full">
                <div
                  className="w-full rounded-lg py-2 text-center font-medium text-sm"
                  style={{
                    backgroundColor: primaryColour,
                    color: buttonTextColour,
                  }}
                >
                  {replaceTokens(values?.emailButtonText) || "Button"}
                </div>
              </div>
            </div>
            {values?.attachPdfStatement && (
              <div className="inline-flex flex-col items-start gap-2 my-3 p-1.5 cursor-default bg-zinc-500 rounded-sm">
                <span className="text-[8px] text-white pb-2.5 truncate">
                  Statement.pdf
                </span>
                <div className="flex text-[8px] items-center justify-center px-[1.5px] py-[3px] bg-red-700 text-white rounded-[2px] font-semibold">
                  PDF
                </div>
              </div>
            )}
            <div className="mt-3">
              <div className="justify-center flex items-end">
                <p className="text-xs text-zinc-700 font-medium cursor-default mb-3">
                  Powered by <strong>Ontik</strong>
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </PhoneFrame>
  );
};

export default EmailPreview;
